import styled from "styled-components";

const Container = styled.section`
  background-color: ${(props) => props.theme.cardBg};
  border: 1px solid ${(props) => props.theme.border};
  border-radius: 12px;
  min-width: 0;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 12px;
  padding: 14px 18px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`;

const Title = styled.h2`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.textColor};
`;

const Description = styled.span`
  font-size: 12.5px;
  color: ${(props) => props.theme.secondaryTextColor};
`;

const Body = styled.div<{ $padding: number }>`
  padding: ${(props) => props.$padding}px;
`;

// Bordered surface used to group related content on a page.
const Panel: React.FC<{
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  padding?: number;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}> = ({ title, description, actions, padding = 18, className, style, children }) => {
  return (
    <Container className={className} style={style}>
      {(title || actions) && (
        <Header>
          <div>
            {title && <Title>{title}</Title>}
            {description && <Description>{description}</Description>}
          </div>
          {actions}
        </Header>
      )}
      <Body $padding={padding}>{children}</Body>
    </Container>
  );
};
export default Panel;
